export const stateHandlers = {
	changeHandler: props => stateField => event => {
		let value = event.target.value;
		const numberValue = parseFloat(value);

		if (!isNaN(numberValue)) {
			value = numberValue;
		}

		props.setState(state => ({
			...state,
			[stateField]: value,
		}));
	},
	onSubmit: props => event => {
		event.preventDefault();
		props.setResult(null, () => {
			props.validateAllHandler(event);
			props.reloadAdvert();
		});
	},
	reset: props => event => {
		event.preventDefault();
		props.reloadAdvert();
		props.setDefaultState();
		props.scrollTo.scrollIntoView(true);
	},
};
